(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["sp-quick-view"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('sp-quick-view')) {
  customElements.define('sp-quick-view', class extends HTMLElement {
    connectedCallback() {
      if (this.bound) return;
      this.bound = true;
      this.trigger = this.querySelector('button');
      this.trigger.addEventListener('click', (event) => {
        event.preventDefault();
        event.stopPropagation();
        if (document.querySelector('.sp-qv-dialog[open]')) return;
        this.open();
      });
    }
    disconnectedCallback() {
      if (this.dialog) {
        this.dialog.close();
        this.dialog.remove();
      }
    }
    open() {
      const fragment = this.querySelector('template').content.cloneNode(true);
      const dialog = fragment.querySelector('dialog');
      this.dialog = dialog;
      document.body.appendChild(dialog);
      const previousOverflow = document.documentElement.style.overflow;
      document.documentElement.style.overflow = 'hidden';
      dialog.addEventListener('close', () => {
        document.documentElement.style.overflow = previousOverflow;
        dialog.remove();
        this.dialog = null;
        if (this.trigger.isConnected) this.trigger.focus();
      }, { once: true });
      dialog.querySelector('.sp-qv-close').addEventListener('click', () => dialog.close());
      dialog.addEventListener('click', (event) => {
        const rect = dialog.getBoundingClientRect();
        if (event.target === dialog && (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom)) dialog.close();
      });
      const select = dialog.querySelector('select[name="id"]');
      const update = () => {
        const option = select.selectedOptions[0];
        const price = dialog.querySelector('.sp-qv-price');
        if (price) price.textContent = option.dataset.price;
        const add = dialog.querySelector('.sp-qv-add');
        if (add) {
          add.disabled = option.dataset.available !== 'true';
          add.textContent = add.disabled ? 'Sold out' : 'Add to basket';
        }
        const quantity = dialog.querySelector('[name="quantity"]');
        quantity.min = option.dataset.min || '1';
        quantity.step = option.dataset.step || '1';
        quantity.value = quantity.min;
        if (option.dataset.max) quantity.max = option.dataset.max;
        else quantity.removeAttribute('max');
        const image = dialog.querySelector('.sp-qv-image');
        if (image && option.dataset.image) {
          image.removeAttribute('srcset');
          image.src = option.dataset.image;
        }
        const link = new URL(dialog.querySelector('.sp-qv-product-link').href);
        link.searchParams.set('variant', option.value);
        dialog.querySelector('.sp-qv-product-link').href = link.href;
      };
      if (select) { select.addEventListener('change', update); update(); }
      const form = dialog.querySelector('form');
      if (form) form.addEventListener('submit', () => {
        const add = dialog.querySelector('.sp-qv-add');
        if (add) { add.disabled = true; add.textContent = 'Adding…'; }
      });
      dialog.showModal();
    }
  });
}
  } catch(e) { console.error(e); }
})();

})();
